<template>
  <div id="compliancedetails" style="text-transform: capitalize;">
    <div data-html2canvas-ignore="true" class="customdim" v-show="loader">
      <div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
    </div>
  	<div class="datepickerwrap">  
  		<div class="leftcontent wrapitem">
  			<div class="datebox" style="width:12%">
  	 			<datepicker placeholder="From"  v-model="date.startDate" />
  	 		</div>
  	 		<div class="datebox">
          <select v-model="selected_website" class="form-control text-uppercase">
          	<optgroup v-for="opt in websiteMenuItems" :label="opt.optgroup" :key="'wmi_optgroup_'+opt.optgroup">
             <option v-for="op in opt.options" :key="'wmi_option_'+op.key" :value="op"> {{ op.label }} </option>
            </optgroup>
          </select>
        </div>
        <div class="datebox" style="width:max-content" >
          <select v-model="selectedItemCategory"   class="form-control text-uppercase">
            <option v-for="d in itemCategoryOptions" :key="'sic_option_' + d.key" :value="d">{{ d.label }} </option>
          </select>
        </div>
  	 		<div class="datebox" style="width:10%">
          <button @click="refresh" class="btn btn-block weavrpurple" type="button">
            <span style="font-size:13px">Submit</span>
          </button>
        </div>
  	 	</div>
      <div class="righcontent wrapitem">
        	<div class="datebox" style="float:right">
          <button @click="backToSov" style="width:max-content;float:right" class="btn btn-block weavrpurple" type="button">
            <i class="fa fa-arrow-left"></i>
            <span style="font-size:13px"> Back</span>
          </button>
        </div>  
      </div>
  	</div>
    <div class="container-fluid ">
      <div class="card p-2">
        <table id="myTable2" class="table table-striped table-bordered" style="transform: rotateX(180deg);">
          <thead class="thead-normal">
            <tr>
              <th v-for="d in compTable.headers" :key="'head_'+d.key"> {{ d.label  }} </th>   
            </tr>
          </thead>
          <tfoot style="display: table-row-group;">
              <tr>
                <th v-for="d in compTable.headers" :key="'foot_'+d.key">{{ d.label  }}</th>
              </tr>
            </tfoot> 
          <tbody class="tbody-normal" > 
            <tr v-for="(r,i) in compTable.data"  :key="'compTable_mcafee_'+ i">
              <td  v-for="d in compTable.headers" :key="'data_'+d.key" :class="{'minWid':d.key == 'product_name'}" > 
                <span v-if="d.key == 'product_name'"><a target="_blank" :href="r['link']">{{r[d.key]}}</a></span>
                <span v-else>{{r[d.key]}}</span>
              </td>
            </tr>
          </tbody>
        </table> 
      </div>  
    </div>  
  </div>  

</template>
<script>   
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import compdetail from './compdetail.json'
export default {
  name: 'compliancedetails',
  components: { Datepicker},
  data: function () {
    return {
      loader: false,
      date:{ startDate: '' },
      websiteMenuItems: [],
      selected_website: {},
      itemCategoryOptions: [],
      selectedItemCategory: {},
      compTable: {  headers: [],data: [] }
    }
  },
  mounted()
  {
    this.initPage()
    this.getComplianceDetails()
  },
  methods: {
    initPage(){
      if (localStorage.startDate) 
      {
        this.date.startDate = localStorage.startDate
      }
      else
      {  
        this.date.startDate = '2021-12-22'
        localStorage.startDate = this.date.startDate 
      }  
      this.websiteMenuItems = [{
        optgroup: 'RETAIL',
        options: [
          // { key: 'all',label:'All' },
          // { key: 'https://www.amazon.de',label:'Amazon Germany' },
          { key: 'https://www.amazon.in',label:'Amazon India' },
          { key: 'https://www.lazada.com',label:'Lazada' },
          // { key: 'https://www.amazon.com',label:'Amazon US' },
          // { key: 'https://www.bestbuy.com',label:'Best Buy US' },
          // { key: 'https://www.costco.com',label:'Costco US' },
          // { key: 'https://www.currys.co.uk',label:"Curry's UK" },
          // { key: 'https://www.harveynorman.com.au',label:'Harvey Norman AU' },
          // { key: 'https://global.jd.com',label:'JD GC' },
          // { key: 'https://www.mediamarkt.de',label:'MediaMarkt DE' },
          // { key: 'https://www.walmart.com',label:'Walmart US' }
        ]
      }]
      if(localStorage.selected_website)
      {
        for(let [i,d] of this.websiteMenuItems.entries() )
        {
          for(let [idx,dd] of d.options.entries() )
          {
            if (dd.key == localStorage.selected_website)   
            {
              this.selected_website = dd
              break;
            }
          } 
        }
        if(!Object.keys(this.selected_website).length)
        {
          this.selected_website = this.websiteMenuItems[0].options[0]
          localStorage.selected_website = this.selected_website.key
        }
      }
      else {
        this.selected_website = this.websiteMenuItems[0].options[0]
        localStorage.selected_website = this.selected_website.key
      }
      this.itemCategoryOptions =  [{ key: 'antivirus_and_security', label: 'Antivirus And Security' }]
      if(localStorage.selected_category)
      {
        for(let [idx,dd] of this.itemCategoryOptions.entries() )
        {
          if (dd.key == localStorage.selected_category)   
          {
            this.selectedItemCategory = dd
            break;
          }
        }  
        if(!Object.keys(this.selectedItemCategory).length)
        {
          this.selectedItemCategory = this.itemCategoryOptions[0]
          localStorage.selected_category = this.selectedItemCategory.key
        }
      }
      else 
      {
        this.selectedItemCategory = this.itemCategoryOptions[0]
        localStorage.selected_category = this.selectedItemCategory.key
      }
    },
  
    backToSov(){ 
      window.location = '#/sov-mcafee'
    },

    format(v){
      return this.$options.filters.format(v)
    },

    refresh(){
      $('#myTable2').DataTable().destroy();
      localStorage.selected_website = this.selected_website.key
      localStorage.selected_category = this.selectedItemCategory.key
      localStorage.startDate = moment(this.date.startDate).format('YYYY-MM-DD')
      this.getComplianceDetails()
    },  
   
    getComplianceDetails(){
      let self = this
      this.compTable.headers  = compdetail.data.headers
      this.compTable.data  = compdetail.data.data
      this.$nextTick(function(){
        self.initDt2()
      })
    },
    
    initDt2(){
      let self = this
      $('#myTable2').DataTable({
        initComplete: function () {
          this.api().columns().every( function () {
              var column = this;
              var select = $("<select><option value=''>All</option></select>")
                  .appendTo( $(column.footer()).empty() )
                  .on( 'change', function () {
                      var val = $.fn.dataTable.util.escapeRegex($(this).val());   
                      column.search( val ? '^'+val+'$' : '', true, false ).draw();
                  } );
              let arr = []    
              let sortedArr = []
              column.data().unique().sort().each( function ( d, j ) {
                if(d=='N/A') d = 'Na'
                var myVal = $(d).text()
                arr.push(myVal)
              } );
                
              sortedArr = arr.sort((a, b) => a.localeCompare(b, navigator.languages[0] || navigator.language, {numeric: true, ignorePunctuation: true}))
              for (let [idx, ds] of sortedArr.entries())
              {
                select.append( "<option>"+ds+"</option>" )
              } 
          } );
        }
      });
      $('#myTable2').wrap("<div class='scrolledDataTable'></div>");
    }
  }
}

</script>

<style scoped>

.custom-table
{
  padding: 10px;
  margin:10px;
}

.markitamd
{
  background-color:#ffb9b9!important
}
.markitintel
{
  background-color:#c7e0ff!important;
}
.markitsnap
{
  background-color:#ffd0f5 !important
}
.markitna
{
  background-color:#edf2fb!important
}
.markittek
{
  background-color:#fff0ce!important
}
.space-between-header
{
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
.space-between-header select
{
  width: fit-content;
  float: right;
  border: 1px solid #c5c5c5;
}
.space-between-header h3 {
  color: #4e4e4e;
    margin-bottom: 0;
    line-height: 31px;
}
.listing-custom
{
    font-size: 18px;
    margin-bottom: 6px;
    text-align: center;
    width: 215px;
    background: #8a87e8;
}
.hint
{
  cursor: pointer;
  background: #f5f5f5;
  color: #080808;
  padding: 3px;
  font-size: 9px;
} 
.amd-legend
{
  text-align: center;
  position: absolute;
  left: 15%;
  right: 15%;
  z-index:999
}
.amd-legend i
{
  
  width: fit-content;
}
.amd-legend span
{
    padding-left: 4px;
    font-size: 12px;
}
.legending
{
  display: inline-block;
  margin-right: 19px;
}
#avgTable th, #avgTable td
{
  border:1px solid #c8ced3!important;
  text-align:left;
  font-size:14px
}
.mycols:first-child
{
 padding-right:2px!important
}
.mycols:last-child
{
 padding-left:2px
}
.mycols:not(:first-child):not(:last-child)
{
 padding-left:2px;
 padding-right:2px
}
.minWid
{
  min-width: 250px;
}
</style>
